// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c8cd28ee","797":"1677b004","952":"841497db"}[chunkId] + ".chunk.js";
};